import React, { useEffect, useRef } from 'react';

import './styles.css';

function Callout({ children, onClickOutSide }) {
    const ref = useRef(null);

    // Fecha o callout ao clicar fora dele
    // Obtido de https://stackoverflow.com/questions/32553158/
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutSide();
            }
        }
        // Bind the events listeners
        document.addEventListener("mousedown", handleClickOutside);
        // O mapa não gera o evendo 'mousedown', então é mantido os dois
        // pois o 'click' não gera o resultado esperado ao clicar nos links
        // que abrem o callout (Se o callout já estiver aberto e clicar em
        // outro link, o outro callout não é aberto)
        document.addEventListener("click", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("click", handleClickOutside);
        };
    }, [ref, onClickOutSide]);

    return (
        <div ref={ref} className='callout-container'>
            <div className='callout-arrow' />
            <div className='callout-body'>
                {children}
            </div>
        </div>
    );
}

export default Callout;